import type { ComponentType } from 'react';
import FluidFieldDetail from './fluid-field';

/**
 * Maps a Work id to its rich-content component. Works without an entry here
 * fall back to a placeholder ("coming soon") in `<WorkDetail>`.
 */
export const detailComponents: Record<string, ComponentType> = {
  'fluid-field': FluidFieldDetail,
};
